import HomeUserProductModal from './HomeUserProductModalPage';

export default HomeUserProductModal;
